import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@services/authentication.service';
import { PermissionOptions, PermissionTypes } from '@services/config.service';
import { StaleSubscription, StaleSubscriptionsService } from '@services/stale-subscriptions.service';

const STALE_REASON_LABELS = {
  'user-not-found': 'User no longer exists',
  'user-deleted': 'User was deleted',
  'share-deleted': 'Shared dashboard was deleted',
  'share-access-removed': 'User no longer has access to the shared dashboard',
};

/**
 * Lists the email subscriptions the screenshot job disabled, because a screenshot can no longer be taken for them
 * (biz/ScreenshotSubscriptions.js in node-restify).
 */
@Component({
  selector: 'app-stale-subscriptions',
  templateUrl: './stale-subscriptions.component.html',
  styleUrls: ['./stale-subscriptions.component.scss'],
  standalone: false
})
export class StaleSubscriptionsComponent implements OnInit {

  displayedColumns: string[] = ['title', 'type', 'emailTo', 'frequency', 'staleReason', 'staleAt', 'actions'];
  dataSource: StaleSubscription[] = [];
  isLoading = false;
  canDelete = false;

  constructor(
    private staleSubscriptionsService: StaleSubscriptionsService,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    const user = this.authenticationService.getCurrentUser();
    this.canDelete = user?.isSurvaleAdmin ||
      !!user?.role?.permJSON?.[PermissionTypes.CanEmailDashboardsSnapshots]?.[PermissionOptions.Edit];
    this.loadStaleSubscriptions();
  }

  loadStaleSubscriptions(): void {
    this.isLoading = true;
    this.staleSubscriptionsService.getStaleSubscriptions().subscribe({
      next: (res: any) => {
        this.dataSource = res.body || [];
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error('Failed to load stale subscriptions');
        this.isLoading = false;
      }
    });
  }

  getReasonLabel(row: StaleSubscription): string {
    return STALE_REASON_LABELS[row.staleReason] || row.staleReason;
  }

  deleteSubscription(row: StaleSubscription): void {
    if (!confirm(`Delete the ${row.frequency}ly subscription of ${row.emailTo} to "${row.title}"?`)) {
      return;
    }
    this.staleSubscriptionsService.deleteStaleSubscription(row).subscribe({
      next: () => {
        this.toastr.success('Subscription deleted');
        this.loadStaleSubscriptions();
      },
      error: () => this.toastr.error('Failed to delete the subscription')
    });
  }
}
